module.exports = __webpack_public_path__ + "img/gift1.ebeb2a19.png";